import TYPES from '@/modules/shared/types';

// Domain
import { LinkSowosWealthModerateRepository } from '../../domain/repositories/link-sowos-wealth-moderate-repository';
import { LinkSowosWealthModerateEntity } from '../../domain/entities/link-sowos-wealth-moderate-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class LinkSowosWealthModerateHttpRepository implements
  LinkSowosWealthModerateRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-goal-linked-investment-product-fund-type/link-wealth-moderate/`;

  link(link_sowos_wealth_moderate: LinkSowosWealthModerateEntity): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', link_sowos_wealth_moderate)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
